'use strict';

import {EvaluationBaseCtrl} from "./evaluationbasectrl.js";
import {evaluationAdmeliModel} from "../../models/evaluationadmelimodel.js";

export class EvaluationAdmeliCtrl extends EvaluationBaseCtrl
{
//	$scope;
//	$filter;
//	$timeout;
//	jsDataService;
//	notify;
//	evaluation = {};
	group = {
		admissibility: ['p1q1', 'p1q2', 'p1q3', 'p1q4', 'p1q5'],
		eligibility: ['p2q1', 'p2q2', 'p2q3', 'p2q4', 'p2q5', 'p2q6', 'p2q7', 'p2q8', 'p2q9']
	};
//	showRequire = false;
//	
//	constructor($scope, $filter, $timeout, jsDataService, notify){
//		'ngInject';
//		this.$scope = $scope;
//		this.$filter = $filter;
//		this.jsDataService = jsDataService;
//		this.notify = notify;
//		this.$timeout = $timeout;
//		this.classif = this.jsDataService.get('cfgClassif', {});
//		this.evaluation = new evaluationAdmeliModel(jsDataService.get('evaluation', {}), $filter, jsDataService);
//		
//	}
	
	postConstruct(){
		let evaluation = this.jsDataService.get('evaluation', {});
		this.evaluation = new evaluationAdmeliModel(evaluation, this.$filter, this.jsDataService);
		if(typeof(evaluation.attachments) === 'object'){
			this.attachments = evaluation.attachments;
		}
	}
	
	getQlist(name){
		let data = [];
		if(typeof(this.group[name]) === 'undefined'){
			return data;
		}
		for(let id of this.group[name]){
			let gr = this.evaluation.data_value.getQuestion(id);
			if(gr){
				data.push(gr);
			}
		}
		return data;
	}
	
	autosavePostFields(){
//		let post = this.evaluation.data_value.questions;
		return {
			questions: this.evaluation.data_value.questions,
			attachments: this.attachments
		};
	}
	
	confirmEvaluation(ev, form){
		this.showRequire = true;
		this.$timeout(()=>{
			if(form.$invalid){
				this.notify(this.$filter('tr')('err_check_required_fields'), true);
			}
			else{
				this.$scope.basicHttpConfigProcess({
					url: this.jsDataService.get('cfgConfirmUrl'),
					method: 'GET',
					params: {}
				});
			}
		});
		
	}
}